import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from 'flarum/common/Model';
export default class GorbeaResult extends Model {
  constructor() {
    super(...arguments);
    _defineProperty(this, "seasonId", Model.attribute('seasonId'));
    _defineProperty(this, "classification", Model.attribute('classification'));
    _defineProperty(this, "maxGoleadorLiga", Model.attribute('maxGoleadorLiga'));
    _defineProperty(this, "maxGoleadorTotal", Model.attribute('maxGoleadorTotal'));
    _defineProperty(this, "maxAsistenteLiga", Model.attribute('maxAsistenteLiga'));
    _defineProperty(this, "maxAsistenteTotal", Model.attribute('maxAsistenteTotal'));
    _defineProperty(this, "resultadoCopa", Model.attribute('resultadoCopa'));
    _defineProperty(this, "porteriasCero", Model.attribute('porteriasCero'));
    _defineProperty(this, "goleadasFavor", Model.attribute('goleadasFavor'));
    _defineProperty(this, "goleadasContra", Model.attribute('goleadasContra'));
    _defineProperty(this, "createdAt", Model.attribute('createdAt', Model.transformDate));
    _defineProperty(this, "updatedAt", Model.attribute('updatedAt', Model.transformDate));
    _defineProperty(this, "season", Model.hasOne('season'));
  }
  apiEndpoint() {
    return '/nagusi/match-ratings/gorbea-result' + (this.exists ? '/' + this.data.id : '');
  }
}
flarum.reg.add('nagusi-match-ratings', 'common/models/GorbeaResult', GorbeaResult);